import Vue from "vue";
import moment from "moment";
import translate from "./translate";
import __staticOptions from "./json/staticOptions.json";

moment.locale("id");
Vue.filter("parse", (value, id) => {
  if (id === "thousandSep" && !value) return 0;
  if (id === null || id === undefined) return value;
  if (value === undefined) return value;
  let toReturn = "";
  if (id.search("-") === -1) {
    switch (id) {
      case "active":
        toReturn = value === "1" || value === 1 ? "Aktif" : "Non Aktif";
        break;
      case "available":
        toReturn = value === "1" || value === 1 ? "Ada" : "Tidak Ada";
        break;
      case "acceptance":
        toReturn = value === "1" || value === 1 || value === true ? "Diterima" : "Kurang Diterima";
        break;
      case "local_acceptance":
        if(value == 0 ){
          toReturn = "Diterima";
        }else if(value == 1){
          toReturn = "Kurang Diterima";
        }else if(value == 2){
          toReturn = "Tidak Diterima";
        }
        break;
      case "potential_status":
        if(value == 0 ){
          toReturn = "Potensial Karbon";
        }else if(value == 1){
          toReturn = "Potensial Non-Carbon";
        }else if(value == 2){
          toReturn = "Potensial Carbon & Non-Carbon";
        }
        break;
      case "critical_land":
        if(value == 0 ){
          toReturn = "Kritis";
        }else if(value == 1){
          toReturn = "Tumbuhan Berjarak";
        }else if(value == 2){
          toReturn = "Hutan Padat";
        }
        break;
      case "water-source_type":
        toReturn = value === "natural" ? "Natural" : "Buatan Manusia";
        break;
      case "verification":
        // toReturn = value === "1" || value === 1 ? "Terverifikasi" : "Belum Terverifikasi";
        if(value == 1){
          toReturn = "Terverifikasi";
        }else if(value == null){
          toReturn = "Belum Terverifikasi";
        }else{
          toReturn = "Belum Terverifikasi";
        }
        break;
      case "project_status":
        if (value == 1) {
          toReturn = "Pending";
        } else if (value == 2) {
          toReturn = "Sukses";
        } else if (value == 3) {
        }
        break;
      case "village_status":
        if (value == 0) {
          toReturn = "Belum Mengikuti RRA";
        } else if (value == 1) {
          toReturn = "Potensial";
        } else if (value == 2) {
          toReturn = "Tidak Potensial";
        }
        break;
      case "event_status":
        if (value == 0) {
          toReturn = "Pending";
        } else if (value == 1) {
          toReturn = "Dijadwalkan";
        } else if (value == 2) {
          toReturn = "Selsai";
        } else if (value == 3) {
        }
        break;
      case "land_status":
        if (value == 1) {
          toReturn = "Terverifikasi";
        } else if (value == 2) {
          toReturn = "Belum Lengkap";
        } else if (value == 0) {
          toReturn = "Belum Verifikasi";
        }
        break;
      case "farmer_status":
        if (value == 1) {
          toReturn = "Terverifikasi";
        } else if (value == 0) {
          toReturn = "Belum Verifikasi";
        }
        break;
      case "farmer_complete_data":
        if (value == 1) {
          toReturn = "Lengkap";
        } else if (value == 0) {
          toReturn = "Belum Lengkap";
        }
        break;
      case "status_overall":
        toReturn = value ? "Selesai" : "Belum Selesai";
        break;
      case "lowercase":
        toReturn = value ? value.toLowerCase() : value;
        break;
      case "calculated":
        toReturn = value === "calculated" ? "Sudah Dihitung" : "Belum Dihitung";
        break;
      case "active-member":
        toReturn = value === 1 ? "Anggota Aktif" : "Non Aktif";
        break;
      case "status_data":
        toReturn = value === 1 ? "Existing" : "New";
        break;
      case "charge":
        toReturn = value === "companies" ? "Perusahaan" : "Tenaga Kerja";
        break;
      case "valsal":
        toReturn = value === "valsal" ? "Vendor/Subkon" : "Kontraktor";
        break;
      case "uppercase":
        toReturn = value.toUpperCase();
        break;
      case "allow":
        toReturn =
          value.toLowerCase() === "y" ? "DIperbolehkan" : "Tidak diizinkan";
        break;
      case "lock":
        toReturn = value.toLowerCase() === "y" ? "Close" : "Open";
        break;
      case "yn":
        toReturn = value.toLowerCase() === "y" ? "Ya" : "Tidak";
        break;
      case "ynBool":
        toReturn = value ? "Ya" : "Tidak";
        break;
      case "prosen":
        toReturn = Number(value).toLocaleString("id-ID") + "%";
        break;
      case "s_komponen":
        toReturn = value + " Komponen";
        break;
      case "count_day_of_work":
        toReturn = value + " Hari Kerja";
        break;
      case "verify":
        if (value === "revision_request") toReturn = "Permintaan Revisi";
        else if (value === "verification_request") {
          toReturn = "Pengajuan Verifikasi";
        } else if (value === "appraisal_request") {
          toReturn = "Permintaan Penilaian";
        } else if (value === "approved") toReturn = "Disetujui";
        else toReturn = "Draft";
        break;
      case "modules":
        if (value === "customer_complaints") toReturn = "Keluhan Pelanggan";
        else if (value === "kkkl_daily_reports") toReturn = "K3L Daily";
        else if (value === "mm_appraisals") toReturn = "SMM";
        else if (value === "qhse_daily_activities") toReturn = "Daily Activity";
        else if (value === "qhse_nc_qa") toReturn = "Non Conformance";
        else if (value === "qpass_appraisals") toReturn = "QPASS";
        else if (value === "smkkkl_appraisals") toReturn = "SMK3L";
        else if (value === "r_appraisals") toReturn = "5R";
        else if (value === "qhse_nc_hse") toReturn = "HSE NC";
        else if (value === "kkkl_accident_cause_analysis") {
          toReturn = "Analisa Penyebab";
        } else if (value === "kkkl_occupt_diss_accidents") {
          toReturn = "Kecelakaan / Penyakit Akibat Kerja";
        } else if (value === "kkkl_critical_plans") {
          toReturn = "Rencana Tugas Kritikal";
        } else if (value === "kkkl_onsite_kkkl_personnels") {
          toReturn = "Tenaga K3L On Site";
        } else if (value === "kkkl_trainings") toReturn = "Pelatihan K3L";
        else if (value === "users_verifications") {
          toReturn = "Verifikasi Pendaftaran";
        } else toReturn = "Unknown";
        break;
      case "number":
        // toReturn = !isNaN(value) ? Number(value).toLocaleString('id') : value
        toReturn = !isNaN(value) ? Number(value).toLocaleString() : value;
        break;
      case "number2fraction":
        toReturn = !isNaN(value)
          ? Number(value).toLocaleString("id", {
              minimumFractionDigits: 2,
              maximumFractionDigits: 2,
            })
          : value;
        break;
      case "money":
        // toReturn = !isNaN(value) ? 'Rp. ' + Number(value).toLocaleString('id') : value
        toReturn = !isNaN(value)
          ? "Rp. " + Number(value).toLocaleString()
          : value;
        break;

      case "longDate":
        if (moment(value, "YYYY-MM-DD", true).isValid()) {
          toReturn = moment(value).format("LL");
        } else toReturn = value;
        break;
      case "longDateTime":
        toReturn = moment(value).format("LLLL");
        break;
      case "period":
        if (moment(value, "YYYY-MM-DD", true).isValid()) {
          toReturn = moment(value).format("MMMM YYYY");
        } else toReturn = value;
        break;
      case "year":
        if (moment(value, "YYYY-MM-DD", true).isValid()) {
          toReturn = moment(value).format("YYYY");
        } else toReturn = value;
        break;
      case "hours":
        let parsed = value.split(":");
        parsed[0] = Number(parsed[0]) > 0 ? Number(parsed[0]) + " Jam" : null;
        parsed[1] = Number(parsed[1]) > 0 ? Number(parsed[1]) + " Menit" : null;
        parsed[2] = Number(parsed[2]) > 0 ? Number(parsed[2]) + " Detik" : null;
        toReturn = parsed.filter((x) => x).join(", ");
        break;
      case "time":
        toReturn = moment(value, "HH:mm:ss").format("LTS a");
        break;
      case "kelamin":
        toReturn = value.toLowerCase() === "male" ? "Laki-Laki" : "Perempuan";
        break;
      case "gender":
        toReturn = value.toLowerCase() === "L" ? "Laki-Laki" : "Perempuan";
        break;
      // case "kawin":
      //   if (value === "single") toReturn = "Belum Menikah";
      //   else if (value === "married") toReturn = "Menikah";
      //   else if (value === "widow") toReturn = "Janda/Duda";
      //   else toReturn = "Tidak Diketahui";
      //   break;
      case "marrital":
        const marritalOptions = __staticOptions.marrital || [];
        const findMarrital = marritalOptions.find(
          (option) => option.code === value
        );
        toReturn = findMarrital ? findMarrital.label : "-";
        break;
      case "religion":
        const religionOptions = __staticOptions.religion || [];
        const findReligion = religionOptions.find(
          (option) => option.code === value
        );
        toReturn = findReligion ? findReligion.label : "-";
        break;
      case "status_code":
        var lang = localStorage.getItem("lang");
        if (!lang || !["en", "id"].includes(lang)) {
          var tmp_val = value
            .toLowerCase()
            .split("_")
            .map(
              (kebab) =>
                kebab.toLowerCase().charAt(0).toUpperCase() + kebab.slice(1)
            )
            .join(" ");
          toReturn = tmp_val.toLowerCase() === "success" ? "Finish" : tmp_val;
          break;
        }
        var key = value.toLowerCase();
        toReturn = translate[lang].global[key] || value;

        break;
      case "status":
        var lang = localStorage.getItem("lang");
        if(value === true || value === false){
          value = value ? "1" : "0"
        }
        if (value == "1") {
          toReturn = "Aktif";
        } else {
          toReturn = "Nonaktif";
        }
        break;

      case "status_code_payment":
        if (value.toLowerCase() === "success") {
          toReturn = "";
        } else if (["pending", "progress"].includes(value.toLowerCase())) {
          toReturn = "Belum Lunas";
        } else {
          toReturn = value
            .toLowerCase()
            .split("_")
            .map(
              (kebab) =>
                kebab.toLowerCase().charAt(0).toUpperCase() + kebab.slice(1)
            )
            .join(" ");
        }
        break;
      case "qa_criteria":
        toReturn = value.toLowerCase() === "hse" ? "HSE" : "Quality";
        break;
      case "handling_category":
        if (value === "corporate") toReturn = "Corporate";
        else if (value === "department") toReturn = "Departemen";
        else toReturn = "Proyek";
        break;
      case "risk_level":
        if (value === 1) toReturn = "Rendah";
        else if (value === 2) toReturn = "Sedang";
        else toReturn = "Tinggi";
        break;
      case "single_number_type":
        if (value === "smk3l") toReturn = "SMK3L";
        else if (value === "mm") toReturn = "Manajemen Mutu";
        else toReturn = "Penilaian 5R";
        break;
      case "is_structural":
        toReturn = value ? "Jabatan Struktural" : "Jabatan non Struktural";
        break;
      case "is_plt":
        toReturn = value === true ? "PLT" : "Non PLT";
        break;
      case "is_mpp":
        toReturn = value === true ? "MPP" : "Non MPP";
        break;
      case "sync":
        toReturn =
          value === "not_synchronized_yet"
            ? "Belum di Sinkronkan"
            : "Sudah di Sinkronkan";
        break;
      case "holiday":
        toReturn = value === "holiday" ? "Hari Libur" : "Hari Kerja";
        break;
      case "is_kiw":
        toReturn = value === "kiw" ? "KIW" : "Eksternal";
        break;
      case "finished":
        toReturn = value === "finished" ? "Sudah Selesai" : "Belum Selesai";
        break;
      case "dateFormat":
        toReturn = moment(value).format("DD MMM YYYY");
        break;

      case "dateTimeFormat":
        toReturn = moment(value).format("DD MMM YYYY HH:mm");
        break;
      case "timeFormat":
        toReturn = moment(value).format("HH:mm");
        break;

      case "phone":
        toReturn = value.replace(/(.{4})/g, "$ $");
        break;
      case "salesOrder":
        if (value.split("/").length < 4) {
          toReturn = value;
          break;
        }
        toReturn = `${value.split("/")[0]}/${value.split("/")[2]}...../${
          value.split("/")[value.split("/").length - 1]
        }`;
        break;

      case "purchaseOrder":
        toReturn = `${value.split("/")[0]}/${value.split("/")[2]}...../${
          value.split("/")[value.split("/").length - 1]
        }`;
        break;

      case "no_empty":
        toReturn = value ? value : "-";
        break;
      case "thousandSep":
        if (typeof value !== "number") return value;
        var a;
        if (value % 1 == 0) {
          a = value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        } else {
          a = parseFloat(value)
            .toFixed(2)
            .toString()
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }

        toReturn = a;
        break;

      case "idr":
        if (!value || typeof value !== "number") return value;
        var val = parseFloat(value).toFixed(2);
        val = val - parseInt(value) > 0 ? val : parseInt(value);
        var a = val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");

        toReturn = `${a.replace(/,/g, ".")},-`;
        break;

      case "floatForce":
        toReturn =
          value !== 0
            ? value
                .toFixed(2)
                .toString()
                .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
            : 0;
        break;

      case "float":
        if (typeof value !== "number") {
          toReturn = value;
        } else {
          let parsedFloat = value.toFixed(0);
          toReturn = Number(parsedFloat);
        }

      default:
        toReturn = value;
    }
  } else {
    switch (id.split("-")[0]) {
      case "prefix":
        toReturn = id.split("-")[1] + " " + value;
        break;
      case "suffix":
        toReturn = value + " " + id.split("-")[1];
        break;
      default:
        toReturn = value;
    }
  }
  return toReturn;
});

Vue.filter("dateFormat", function (value) {
  return value ? moment(value).format("DD MMM YYYY") : "-";
});

Vue.filter("dateTimeFormat", function (value) {
  return moment(value).format("DD MMM YYYY HH:mm");
});

Vue.filter("timeFormat", function (value) {
  return value ? moment(value).format("HH:mm") : "-";
});
Vue.filter("float", function (value) {
  return value.toFixed(2).replace(/\.0*$|(\.\d*[1-9])0+$/, "$1");
});

Vue.filter("floatForce", function (value) {
  return value > 0
    ? value
        .toFixed(2)
        .toString()
        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
    : 0;
});

Vue.filter("AH", function (value) {
  if (!value || typeof value !== "string") return value;
  let arr = value.split(" ");
  if (arr.length === 1) return value.substring(0, 2).toUpperCase();
  return (
    arr[0].charAt(0).toUpperCase() + arr[arr.length - 1].charAt(0).toUpperCase()
  );
});

Vue.filter("capitalize", function (value) {
  const words = value.replace("-", " ").split(" ");

  for (let i = 0; i < words.length; i++) {
    words[i] = words[i][0].toUpperCase() + words[i].substr(1);
  }

  return words.join(" ");
});

Vue.filter("timeDiff", function (value) {
  if (!value || !moment(value).isValid()) return "-";
  const dateNow = moment();
  const date = moment(value);

  const diffDay = dateNow.diff(date, "days");
  if (dateNow.format("DD") === date.format("DD")) {
    return `Today, ${moment(value).format("HH:mm")} WIB`;
  } else if (diffDay === 1) {
    return `Yesterday, ${moment(value).format("HH:mm")} WIB`;
  } else if (diffDay <= 6) {
    return `${moment(value).format("dddd")}, ${moment(value).format(
      "HH:mm"
    )} WIB`;
  } else {
    return `${moment(value).format("DD MMM YYYY")}, ${moment(value).format(
      "HH:mm"
    )} WIB`;
  }
});

Vue.filter("firstCharacter", function (value) {
  return value.charAt(0).toUpperCase();
});

export default {
  name: "filterTemplate",
};



// WEBPACK FOOTER //
// ./src/utils/filter.js